module.exports = __webpack_public_path__ + "img/nav.a65a88ed.jpg";